import { FlowChartNode } from './flow-chart-node';
import { FlowChartLink } from './flow-chart-link';

export class FlowChartGraph {
  nodes: FlowChartNode[];
  links: FlowChartLink[];
}
